<template>
    <div class="grid">
        <div class="col-12">
            <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
            <div class="card mt-5"  v-if="!isEdit">
                <h5>Form Detail</h5>
                <div class="formgroup-inline">
                    <div class="field">
                        <label for="dd" class="font-medium">Input Candidate Name</label>
                        <AutoComplete forceSelection placeholder="Search" id="dd" :dropdown="true" v-model="selectedAutoValue"
                            :suggestions="autoFilteredValue" @complete="searchCandidate($event)" @item-select="selectCandidate()" field="name" :disabled="isSelected"/>
                        <Button label="Remove" class="p-button-primary mr-2 ml-2" @click="clearSelected" :disabled="!isSelected"/>
                    </div>
                </div>
            </div>
            <div class="card">
                <h4>Detail Psikotest</h4>
                <TabView v-model:activeIndex="active">
                    <TabPanel header="Candidate Information" :disabled="!isSelected">
                        <PersonalVue :model="candidate" :isDisabled="!isSelected"></PersonalVue>
                        <div class="p-fluid">
                            <Button @click="active = 1" id="button1" label="Next" :disabled="!isSelected" />
                        </div>
                    </TabPanel>
                    <TabPanel header="Setup Placement" :disabled="!isSelected">
                        <SetupPlacementVue :model="candidate" ref="placement"></SetupPlacementVue>
                        <div class="p-fluid">
                            <Button @click="active = 2" label="Next" :disabled="!isSelected"/>
                        </div>
                    </TabPanel>
                    <TabPanel header="Psikotest" :disabled="!isSelected">
                        <PsikotestAssessement :model="candidate" ref="assessement"></PsikotestAssessement>
                        <div class="p-fluid">
                            <Button label="Save" @click="store" :disabled="!isSelected"/>
                        </div>
                    </TabPanel>
                </TabView>
            </div>
        </div>
    </div>
</template>
<script>
import Button from "primevue/button";
import Breadcrumb from "primevue/breadcrumb";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import InputText from "primevue/inputtext";
import AutoComplete from 'primevue/autocomplete';
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import AppLayout from '../../../Layouts/AppLayout';
import PersonalVue from "./Components/PersonalInfo";
import SetupPlacementVue from "./Components/SetupPlacement.vue";
import PsikotestAssessement from "./Components/PsikotestAssessement";
import axios from "axios";

export default {
    layout: AppLayout,
    components: {
        Breadcrumb, Dropdown, Calendar, InputText, AutoComplete, Button, TabView, TabPanel, PersonalVue, SetupPlacementVue, PsikotestAssessement,
    },
    props: ['candidate'],
    data() {
        return {
            submitted: false,
            candidate: [],
            autoFilteredValue: [],
            selectedAutoValue: '',
            isEdit: false,
            isSelected: false,
            active: 0,
            form: this.$page.props.psikotest,
            breadcrumbHome: {icon: 'pi pi-home'},
            breadcrumbItems: [
                {label:'Computer'},
                {label:'Notebook'},
                {label:'Accessories'},
                {label:'Backpacks'},
                {label:'Item'}
            ],
        }
    },
    computed: {

    },
    mounted() {
        if(this.$page.props.psikotest){
            this.selectedAutoValue = this.$page.props.psikotest.applicant;
            this.selectCandidate(this.$page.props.psikotest.applicant_id);
            this.isEdit = true;
        }
    },
    methods: {
        searchCandidate(event) {
				setTimeout(() => {
					if (!event.query.trim().length) {
                        axios.get(`${this.$page.props.appUrl}api/applicants`)
                        .then((data)=>{
                            this.autoFilteredValue = data.data.data;
                        });
					}
					else {
                        let filterValue = event.query.toLowerCase();
                        axios.get(`${this.$page.props.appUrl}api/applicants?search=${filterValue}`)
                        .then((data)=>{
                            this.autoFilteredValue = data.data.data;
                        });
					}
				}, 250);
			},
        selectCandidate(id){
            this.isSelected = true;
            if(!id){
                id = this.selectedAutoValue.id;
            }
            axios.get(`${this.$page.props.appUrl}api/applicants/${id}`)
                .then((data) => {
                    this.candidate = data.data.data;
                });
        },
        clearSelected(){
            this.selectedAutoValue = '';
            this.isSelected = false;
        },
        store(){
            let placement = this.$refs.placement.form;
            let assessement = this.$refs.assessement.assessements;
            let form_assessement = this.$refs.assessement.form;
            let new_assessement = [];
            const keys = Object.keys(assessement);

            keys.forEach((key, index) => {
                var obj = {};
                obj[assessement[index]['field_name']] = assessement[index]['value'];
                new_assessement.push(obj);
            });

            let judul = {...new_assessement};
            let payload = {applicant_id: this.candidate.id ,...placement, ...form_assessement, assessements: judul};

            if(this.isEdit){
                axios.put(`${this.$page.props.appUrl}api/applicant-psikotests/${this.$page.props.psikotest.id}`,payload)
                .then((data) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Candidate Psikotest Updated",
                        life: 3000,
                    });
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error When Updating Psikotest",
                        detail: error,
                        life: 3000,
                    });
                })
            }
            else{
                axios.post(`${this.$page.props.appUrl}api/applicant-psikotests`,payload)
                .then((data) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Candidate Psikotest Created",
                        life: 3000,
                    });
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error When Created Psikotes",
                        detail: error,
                        life: 3000,
                    });
                })
            }
        }
    }
}
</script>
